jQuery(function ($) {
  $("#qa-accordion").on("click", "button[data-target]", function (e) {
    e.preventDefault();

    var $btn = $(this);
    var target = $btn.attr("data-target");
    var $target = $(target);

    $("#qa-accordion .collapse.in").not($target).collapse("hide");

    $target.collapse("toggle");
  });

  $("#qa-accordion")
    .on("show.bs.collapse", ".collapse", function () {
      var targetId = "#" + this.id;
      $('button[data-target="' + targetId + '"]').attr("aria-expanded", "true");
    })
    .on("hide.bs.collapse", ".collapse", function () {
      var targetId = "#" + this.id;
      $('button[data-target="' + targetId + '"]').attr(
        "aria-expanded",
        "false"
      );
    });
});
